import {
  generateUsePrismaObjectSyncFindMany,
  generateUsePrismaObjectSyncFindFirst,
  generateUsePrismaObjectSyncFindFirstOrThrow,
  ObjectPoolModelToStateGraphConfig,
  generateUsePrismaObjectAsyncFindMany,
  generateUsePrismaObjectAsyncFindFirst,
  generateUsePrismaObjectAsyncFindManyQueryKey,
} from "./queries";
import { generateBoundBatchUpdateObjectPoolRecordMutation } from "../hooks/useBatchUpdateObjectPoolRecordMutation";
import { generateBoundUseCreateObjectPoolMutation } from "../hooks/useCreateObjectPoolRecordMutation";
import { generateBoundUseDeleteManyObjectPoolMutation } from "../hooks/useDeleteManyObjectPoolRecordMutation";
import { generateBoundUseDeleteObjectPoolMutation } from "../hooks/useDeleteObjectPoolRecordMutation";
import { generateBoundUseUpdateObjectPoolMutation } from "../hooks/useUpdateObjectPoolRecordMutation";
import { generateBoundUseUpsertOneObjectPoolMutation } from "../hooks/useUpsertOneObjectPoolMutation";

export function generateUsePrismaSyncQueries<
  TModelName extends keyof ObjectPoolModelToStateGraphConfig,
>(objectName: TModelName) {
  return {
    findMany: generateUsePrismaObjectSyncFindMany(objectName),
    findFirst: generateUsePrismaObjectSyncFindFirst(objectName),
    findFirstOrThrow: generateUsePrismaObjectSyncFindFirstOrThrow(objectName),
    create: generateBoundUseCreateObjectPoolMutation(objectName),
    update: generateBoundUseUpdateObjectPoolMutation(objectName),
    upsertOne: generateBoundUseUpsertOneObjectPoolMutation(objectName),
    delete: generateBoundUseDeleteObjectPoolMutation(objectName),
    deleteMany: generateBoundUseDeleteManyObjectPoolMutation(objectName),
    batchUpdate: generateBoundBatchUpdateObjectPoolRecordMutation(objectName),

    // ASYNC
    findManyAsync: generateUsePrismaObjectAsyncFindMany(objectName),
    findFirstAsync: generateUsePrismaObjectAsyncFindFirst(objectName),
    findManyQueryKey: generateUsePrismaObjectAsyncFindManyQueryKey(objectName),
  };
}

export const usePrismaObjectSync = {
  accessExtension: generateUsePrismaSyncQueries("AccessExtension"),
  accessProfile: generateUsePrismaSyncQueries("AccessProfile"),
  accessProfileMemberRelationship: generateUsePrismaSyncQueries("AccessProfileMemberRelationship"),
  benefit: generateUsePrismaSyncQueries("Benefit"),
  benefitAssignment: generateUsePrismaSyncQueries("BenefitAssignment"),
  exchangeRate: generateUsePrismaSyncQueries("ExchangeRate"),
  benefitsPackage: generateUsePrismaSyncQueries("BenefitsPackage"),
  equityGrant: generateUsePrismaSyncQueries("EquityGrant"),
  company: generateUsePrismaSyncQueries("Company"),
  companyOnboardingConfig: generateUsePrismaSyncQueries("CompanyOnboardingConfig"),
  compensationApproval: generateUsePrismaSyncQueries("CompensationApproval"),
  compensationApprovalLevel: generateUsePrismaSyncQueries("CompensationApprovalLevel"),
  customField: generateUsePrismaSyncQueries("CustomField"),
  dataImport: generateUsePrismaSyncQueries("DataImport"),
  family: generateUsePrismaSyncQueries("Family"),
  familyGroup: generateUsePrismaSyncQueries("FamilyGroup"),
  fileUpload: generateUsePrismaSyncQueries("FileUpload"),
  grantType: generateUsePrismaSyncQueries("GrantType"),
  integration: generateUsePrismaSyncQueries("Integration"),
  job: generateUsePrismaSyncQueries("Job"),
  level: generateUsePrismaSyncQueries("Level"),
  logicGraph: generateUsePrismaSyncQueries("LogicGraph"),
  logicRun: generateUsePrismaSyncQueries("LogicRun"),
  objective: generateUsePrismaSyncQueries("Objective"),
  performanceAnswer: generateUsePrismaSyncQueries("PerformanceAnswer"),
  performanceCycle: generateUsePrismaSyncQueries("PerformanceCycle"),
  performanceQuestion: generateUsePrismaSyncQueries("PerformanceQuestion"),
  performanceRating: generateUsePrismaSyncQueries("PerformanceRating"),
  presence: generateUsePrismaSyncQueries("Presence"),
  proposal: generateUsePrismaSyncQueries("Proposal"),
  proposerBudget: generateUsePrismaSyncQueries("ProposerBudget"),
  range: generateUsePrismaSyncQueries("Range"),
  rangeSet: generateUsePrismaSyncQueries("RangeSet"),
  rangeUpload: generateUsePrismaSyncQueries("RangeUpload"),
  review: generateUsePrismaSyncQueries("Review"),
  reviewSetupConfig: generateUsePrismaSyncQueries("ReviewSetupConfig"),
  reviewTableFilterState: generateUsePrismaSyncQueries("ReviewTableFilterState"),
  savedBenchmarkJob: generateUsePrismaSyncQueries("SavedBenchmarkJob"),
  internalJob: generateUsePrismaSyncQueries("InternalJob"),
  tableSettings: generateUsePrismaSyncQueries("TableSettings"),
  emailAddress: generateUsePrismaSyncQueries("EmailAddress"),
  userTableState: generateUsePrismaSyncQueries("UserTableState"),
  // @ts-expect-error TS2345
  fieldTextSetting: generateUsePrismaSyncQueries("FieldTextSetting"),

  fieldTablePlacementConfig: generateUsePrismaSyncQueries("FieldTablePlacementConfig"),
  track: generateUsePrismaSyncQueries("Track"),
  user: generateUsePrismaSyncQueries("User"),
  zone: generateUsePrismaSyncQueries("Zone"),
  weightedComp: generateUsePrismaSyncQueries("WeightedComp"),
};
